import { render, staticRenderFns } from "./AdventureTour3.vue?vue&type=template&id=f707c56c&scoped=true&"
import script from "./AdventureTour3.vue?vue&type=script&lang=ts&"
export * from "./AdventureTour3.vue?vue&type=script&lang=ts&"
import style0 from "./AdventureTour3.vue?vue&type=style&index=0&id=f707c56c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f707c56c",
  null
  
)

export default component.exports